module.exports = __webpack_public_path__ + "static/media/tailor.9efd7ca3.jpg";